module.exports = __webpack_public_path__ + "img/m-wash3pro-back.7c9de8e9.jpg";